import React, { useState, useEffect } from 'react';
import { Button, Input, Rate } from 'antd';
import { Fragment } from 'react';
import { getUA } from 'react-device-detect';
import { APP_VERSION } from '../../services/environments';
import { sendPlatformReview } from '../../services/profile';
import { FeedbackMinImg } from '../../utilities/resources';
import ModalBox from './ModalBox';
import { CheckCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;

function Feedback(props) {
  const { isModalVisible, setIsModalVisible } = props;
  const [reviewText, setReviewText] = useState('');
  const [visibleThanksModal, setVisibleThanksModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [reviewData, setReviewData] = useState({});
  const [loading, setLoading] = useState(false);
  const [preFilledReview, setPreFilledReview] = useState([]);
  const [showCommentBox, setShowCommentBox] = useState(false);

  useEffect(() => {
    setReviewData({});
    setRating(0);
    setPreFilledReview([]);
    setReviewText('');
    setShowCommentBox(false);
  }, [isModalVisible]);

  const starChange = (value) => {
    setPreFilledReview([]);
    setShowCommentBox(false);
    setReviewText('');
    setLoading(true);
    setRating(value);
  };

  const feedbackText = (value) => {
    setReviewText(value);
  };

  const avoidSpace = (event) => {
    if (event.target.value.length > 1 && event.target.value.indexOf(' ') >= 0) {
      if (event.which === 32) {
        return false;
      } else {
        return true;
      }
    }
  };

  const sendReview = () => {
    const reviews = getPreFilledReview();
    if (rating !== 0) {
      let data = {
        platform: 'WEB',
        appVersion: APP_VERSION,
        device: getUA,
        rating: rating,
        comment: reviewText.trim(),
      };
      sendPlatformReview(data)
        .then((response) => {
          countDown();
          setReviewText('');
          setRating(0);
          localStorage.setItem('isAppReviewed', true);
        })
        .catch((error) => {
          console.log(error);
        });
      setIsModalVisible(false);
    }
  };

  const countDown = () => {
    let secondsToGo = 20;
    setVisibleThanksModal(true);
    const timer = setInterval(() => {
      secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      setVisibleThanksModal(false);
    }, secondsToGo * 1000);
  };

  const handleCheckboxChange = (e, items) => {
    const { value, checked } = e.target;
    if (checked) {
      if (value === items.id && items.isOthers) {
        setShowCommentBox(true);
      }
      if (preFilledReview.length === 0) {
        setPreFilledReview([items]);
      } else {
        preFilledReview.forEach((items1) => {
          if (items1.id !== items.id) {
            setPreFilledReview([...preFilledReview, items]);
          }
        });
      }
    } else {
      if (value === items.id && items.isOthers) {
        setShowCommentBox(false);
      }
      const filtered = preFilledReview.filter((items2) => items2.id !== value);
      setPreFilledReview(filtered);
    }
  };

  const getPreFilledReview = () => {
    let reviews = [];
    let reviewTextArr = [];
    preFilledReview.forEach((items) => {
      if (items.isOthers) {
        const reviewObj = {
          id: items.id,
          isOthers: items.isOthers,
          comment: reviewText.trim(),
        };
        reviews.push(reviewObj);
        reviewTextArr.push(reviewText.trim());
      } else {
        const reviewObj = {
          id: items.id,
        };
        reviews.push(reviewObj);
        reviewTextArr.push(items.title);
      }
    });
    return reviewTextArr.join();
  };

  return (
    <Fragment>
      <ModalBox title='' visible={isModalVisible} setVisible={setIsModalVisible} width='715px' bodyStyle={{ padding: 0 }}>
        <div id='feedbackForm' className='feedbackModal'>
          <div className='feedbackModalMedia'>
            <img src={FeedbackMinImg} alt='Feedback' />
          </div>
          <div className='feedbackModalContent'>
            <h1>We’re all ears</h1>
            <p>Your feedback helps us improve the product, so that you have a better experience the next time you visit us.</p>
            <div className='feedbackRate'>
              <Rate onChange={starChange} value={rating} />
            </div>
            {rating !== 0 && (
              <TextArea
                value={reviewText}
                type='textarea'
                autoSize={{ minRows: 4, maxRows: 4 }}
                placeholder='Type your feedback here...'
                allowClear
                onChange={(ev) => feedbackText(ev.target.value)}
                onKeyPress={avoidSpace}
                size='large'
                className='feebackTextbox feedbackTextarea'
              />
            )}
            <Button disabled={rating === 0} onClick={sendReview} type='primary' className='feebackSubmitButton'>
              SUBMIT
            </Button>
          </div>
        </div>
      </ModalBox>
      <ModalBox title='' visible={visibleThanksModal} setVisible={setVisibleThanksModal} width='400px' bodyStyle={{ padding: 30 }}>
        <div className='feedbackThanks'>
          <CheckCircleOutlined />
          <div>
            Thanks for your feedback!
            <br />
            It means a lot to us.
          </div>
        </div>
      </ModalBox>
    </Fragment>
  );
}

export default Feedback;
